import {Container, SmallView, Text1, Title1, View} from "../../../../styles/business-components";
import * as S from './styles'

import Image from '../../../../assets/images/business/b_m_cnt2_img1.png'

export const Content2 = () => {
    return (
        <Container>
            <View>
                <S.Content>
                    <div>
                        <Title1>Быстро отправляйте в зашифрованном виде документы и сообщения даже партнерам извне</Title1>
                        <Text1>Общайтесь безопасно с деловыми партнерами по всему миру бесплатно.</Text1>
                        <Text1>Просто и безопасно передавайте знания и информацию.</Text1>
                    </div>
                    <div>
                        <S.Image src={Image}/>
                    </div>
                </S.Content>
            </View>
            <SmallView>
                <Title1>Быстро отправляйте в зашифрованном виде документы и сообщения даже партнерам извне</Title1>
                <S.SmallContent>
                    <div>
                        <Text1>Общайтесь безопасно с деловыми партнерами по всему миру бесплатно.</Text1>
                        <Text1>Просто и безопасно передавайте знания и информацию.</Text1>
                    </div>
                    <div>
                        <S.Image src={Image}/>
                    </div>
                </S.SmallContent>
            </SmallView>
        </Container>
    )
}